var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form',{staticClass:"form",class:{
    'form--disabled': _vm.disabled,
    'form--dirty': _vm.dirty,
    'form--submit-attempted': _vm.submitAttempted
  },attrs:{"id":_vm.name,"data-vv-scope":_vm.name,"novalidate":"","autocomplete":"off"},on:{"submit":_vm.submit,"input":_vm.markFormAsDirty,"change":_vm.markFormAsDirty}},[_c('fieldset',{staticClass:"form__fieldset",attrs:{"disabled":_vm.disabled}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }